<template>
  <div>
    <el-dialog
      top="2vh"
      width="1200px"
      style="height: 96vh"
      center
      :title="
        smsHistoryObj.bankCardNumber
          ? `${smsHistoryObj.bankCardNumber
              .match(/.{1,4}/g)
              .join(' ')} 全部短信`
          : ''
      "
      :visible="smsHistoryObj.visible"
      @close="HandleCancel()"
    >
      <div v-loading="tableLoading">
        <el-table :data="dataList" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <span style="color: blue">{{ scope.row.content }}</span>
            </template>
          </el-table-column>

          <el-table-column label="信息">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.content" placement="top">
                <div>{{ HandleReadMore(scope.row.content, 20) }}</div>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            width="153"
            prop="fromPhoneNumber"
            label="来源"
          ></el-table-column>

          <el-table-column width="170" label="类型">
            <template slot-scope="scope">
              {{ smsType.orderType[scope.row.orderType] }} -
              {{ smsType.type[scope.row.smsType] }}
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            width="153"
            prop="receivedTime"
            label="接收时间"
          ></el-table-column>
          <el-table-column
            align="center"
            width="153"
            prop="createTime"
            label="入库时间"
          ></el-table-column>
          <el-table-column
            align="center"
            width="153"
            prop="updateTime"
            label="更新时间"
          ></el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="pageQuery.pageNum"
          :limit.sync="pageQuery.pageSize"
          @pagination="getSmsHistoryList"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row>
          <div style="float: right">
            <el-button type="primary" size="small" @click="HandleCancel()">
              确定
            </el-button>
          </div>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import Pagination from "@/views/components/Pagination";
import { getSmsHistoryList } from "@/api/smsHistory";

export default {
  mixins: [mainCommon],
  props: ["smsHistoryObj"],
  data() {
    return {
      tableLoading: false, // 全部短信弹窗 loading
      total: 0,
      pageQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
        accId: "",
      },
      smsType: {},
      dataList: [],
    };
  },
  watch: {
    smsHistoryObj(row) {
      if (row.visible) {
        this.smsType = varCommon.smsType;
        this.pageQuery.accId = this.smsHistoryObj.id;
        this.getSmsHistoryList();
      }
    },
  },
  components: {
    Pagination,
  },
  methods: {
    getSmsHistoryList() {
      this.tableLoading = true;
      getSmsHistoryList(this.ObjectClean(this.pageQuery))
        .then((res) => {
          this.total = res.data.total;
          this.dataList = res.data.list;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    HandleCancel() {
      this.$emit("update:sms-history-obj", {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/SmsHistory.vue